/// <amd-module name="Widgets/SDKWidget/SampleConfig" />
import { ConfigProps } from "Dashboards/WidgetContracts/Internal/ConfigProps";
import { DashboardWidgetProps, WidgetGridSize } from "Dashboards/WidgetContracts/Internal/DashboardWidgetProps";
import * as React from "react";
import { VssComponent } from "VSS/Platform/Layout";

import { isNameValid, NameField } from "Dashboards/CommonConfig/NameField";
import { SizePicker } from "Dashboards/CommonConfig/SizePicker";

/**
 * This sample is an engineering "canary" to evaluate the simplicity of the widget configuration contract
 */
export class SampleConfig extends VssComponent<ConfigProps> {
    public static readonly componentType = "sampleWidgetConfig";

    constructor(props: ConfigProps) {
        super(props);
        this.state = {
            name: this.props.config.name,
            size: this.props.config.size
        };
    }

    public componentDidMount(): void {
        this.props.parentProps.onConfigLoaded(); // The configuration experience becomes visible after this point.
    }

    public componentDidUpdate(prevProps: Readonly<ConfigProps>): void {
        if (prevProps.saveValidationTimeStamp !== this.props.saveValidationTimeStamp) {
            const currentConfig = this.props.config;
            this.props.parentProps.onValidationResponse(currentConfig, this.isConfigValid(currentConfig));
        }
    }

    public render(): JSX.Element | undefined {
        return (
            <div className="sample-config">
                <NameField value={this.props.config.name} onChange={this.onNameChanged} />

                {this.props.contributionConstraints.supportedSizes.length > 1 && (
                    <SizePicker
                        key="size-picker"
                        onChange={this.onSizeChanged}
                        sizes={this.props.contributionConstraints.supportedSizes}
                        value={this.props.config.size}
                    />
                )}
                <div>Custom Configuration elements go here!</div>
            </div>
        );
    }

    private isConfigValid(props: DashboardWidgetProps): boolean {
        return isNameValid(props.name);
    }

    /* Pass Name changes up to parent. */
    private onNameChanged = (value: string): void => {
        const newConfig = { ...this.props.config, name: value };
        this.props.parentProps.onUpdate(newConfig);
    };

    /* Pass Size changes up to parent. */
    private onSizeChanged = (value: WidgetGridSize): void => {
        const newConfig = { ...this.props.config, size: value };
        this.props.parentProps.onUpdate(newConfig);
    };
}

VssComponent.register(SampleConfig.componentType, SampleConfig);
